import { Alert, Snackbar, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "./reducers";

const CustomizedSnackbars = () => {
  const dispatch = useDispatch();
  const snackbarOpen = useSelector(state => state.snackbar.snackbarOpen);
  const snackbarType = useSelector(state => state.snackbar.snackbarType);
  const snackbarMessage = useSelector(state => state.snackbar.snackbarMessage)


  const data = {    
    vertical: 'top',
    horizontal: 'right',
  }
  const { vertical, horizontal} = data;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setSnackbar(false, snackbarType, snackbarMessage));
  };

  return (
    <div style={{position:'absolute',zIndex:99999}}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        sx={{color:'white'}}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          color={snackbarType}
          severity={snackbarType}
          className="rounded-sm flex items-center text-white"
        >
         <Typography sx={{color:'white'}}>{snackbarMessage}</Typography>
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CustomizedSnackbars;
